import request from '@/utils/request'

// 查询报告识别列表
export function listTencentOcr(query) {
    return request({
        url: '/biz/tencentOcr/list',
        method: 'get',
        params: query
    })
}
// 查询报告识别列表
export function searchListTencentOcr(query) {
    return request({
        url: '/biz/tencentOcr/searchList',
        method: 'get',
        params: query
    })
}

// 查询报告识别详细
export function getTencentOcr(id) {
    return request({
        url: '/biz/tencentOcr/' + id,
        method: 'get'
    })
}

// 新增报告识别
export function addHandTencentOcr(data) {
    return request({
        url: '/biz/tencentOcr/addHand',
        method: 'post',
        data: data
    })
}
// 新增报告识别
export function editHandTencentOcr(data) {
    return request({
        url: '/biz/tencentOcr/editHand',
        method: 'post',
        data: data
    })
}


// 新增报告识别
export function addTencentOcr(data) {
    return request({
        url: '/biz/tencentOcr',
        method: 'post',
        data: data
    })
}

// 修改报告识别
export function updateTencentOcr(data) {
    return request({
        url: '/biz/tencentOcr/update',
        method: 'post',
        data: data
    })
}

export function updateTencentOcrResult(data) {
    return request({
        url: '/biz/tencentOcr/result/update',
        method: 'post',
        data: data
    })
}

// 删除报告识别
export function delTencentOcr(id) {
    return request({
        url: '/biz/tencentOcr/delete/' + id,
        method: 'post'
    })
}
